var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('form-1',{ref:"form1",on:{"finish":function($event){_vm.nextState_1 = $event}}}),_c('form-2',{ref:"form2",on:{"finish":function($event){_vm.nextState_2 = $event}}}),_c('form-4',{ref:"form4",on:{"finish":function($event){_vm.nextState_4 = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }